import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import { getConfigValue } from '@jutro/config';
import { createTSMRequest } from './tsmHelpers';
export var fetchTsmMessages = function fetchTsmMessages(language, worksetUid, stringGroup) {
  var serverUrl,
      stringVersion,
      jutroVersion,
      url,
      httpRequest,
      parameters,
      _args = arguments;
  return _regeneratorRuntime.async(function fetchTsmMessages$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          serverUrl = _args.length > 3 && _args[3] !== undefined ? _args[3] : getConfigValue('JUTRO_TSM_SERVER');
          stringVersion = _args.length > 4 ? _args[4] : undefined;
          jutroVersion = _args.length > 5 ? _args[5] : undefined;
          url = "/api/v2/worksets/".concat(worksetUid, "/string-groups/").concat(stringGroup, "/strings-react/").concat(language);
          httpRequest = createTSMRequest(serverUrl).build();
          parameters = {
            jutroVersion: jutroVersion || "5.3.1"
          };
          if (stringVersion) parameters.version = stringVersion;
          _context.next = 9;
          return _regeneratorRuntime.awrap(httpRequest.get(url, parameters));

        case 9:
          return _context.abrupt("return", _context.sent.data);

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
};